function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "20",
  height: "22",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 11.304h20c0 5.523-4.477 10-10 10s-10-4.477-10-10z",
  fill: "#3E546D"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#FFAE00",
  x: "1.391",
  y: "5.043",
  width: "2.261",
  height: "5.739",
  rx: "1.13"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#3D77FD",
  x: "16.696",
  y: "4.261",
  width: "2.261",
  height: "6.522",
  rx: "1.13"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#FFAE00",
  x: "4.435",
  y: "1.913",
  width: "2.261",
  height: "8.87",
  rx: "1.13"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#3D77FD",
  x: "13.652",
  y: "1.217",
  width: "2.261",
  height: "9.565",
  rx: "1.13"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.478 4.35c0-.626.502-1.133 1.13-1.133.625 0 1.131.497 1.131 1.133v5.3c0 .626-.502 1.133-1.13 1.133-.625 0-1.13-.497-1.13-1.133v-5.3zM10.609 1.134a1.13 1.13 0 112.26 0v8.515a1.13 1.13 0 11-2.26 0V1.134z",
  fill: "#00D5B4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.043 17.74l-.546 2.23c-.274 1.12.386 1.72 1.48 1.334l2.719-.956-3.653-2.609z",
  fill: "#3E546D"
}))));